var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import alertsTriggerAnalyticsEvent, { analyticsHelper } from '../../helpers/analyticsMiddleware';
import { useProfileQueryData } from '../../helpers/syfApiQueries';
import SyfStorage from '../../helpers/SyfStorage';
import { getAllAlerts, resetAlertsData } from '../../redux/alertsData/actions';
import { setContactInfo, setProfileApiError } from '../../redux/profileData/reducer';
import { getAlertsData } from '../../redux/selectors';
import AlertsLazyLoader from '../../ui/molecules/AlertsLazyLoader';
import ErrorPage from '../ErrorPage';
var AlertList = React.lazy(function () { return import('../../ui/organisms/AlertList'); });
var TermsConsentBanner = React.lazy(function () { return import('../../ui/organisms/TermsConsentBanner'); });
var ContactInformationCard = React.lazy(function () { return import('../../ui/organisms/ContactInformation'); });
var Alerts = function (_a) {
    var _b, _c, _d, _e;
    var analyticsAccountInfoMessage = _a.analyticsAccountInfoMessage, appConfig = _a.appConfig, clientId = _a.clientId, isPageLoaded = _a.isPageLoaded, productType = _a.productType, syfIdentifier = _a.syfIdentifier;
    var platform = appConfig === null || appConfig === void 0 ? void 0 : appConfig.platform;
    var dispatch = useDispatch();
    var _f = useSelector(getAlertsData, shallowEqual), hasError = _f.error, isAlertsDataLoaded = _f.isLoaded;
    var _g = useProfileQueryData(appConfig.config, syfIdentifier), data = _g.data, isProfileDataLoading = _g.isLoading, error = _g.error, isError = _g.isError;
    var phone = ((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.find(function (phoneNumber) { return (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.contactType) === 'MOBILE'; })) === null || _d === void 0 ? void 0 : _d['cipher.contactNumber']) || '';
    var email = ((_e = data === null || data === void 0 ? void 0 : data.profile) === null || _e === void 0 ? void 0 : _e['cipher.email']) || '';
    var isLoading = !isAlertsDataLoaded || isProfileDataLoading;
    var currentLanguage = "us|".concat(SyfStorage.getLanguage());
    var loadAlerts = useCallback(function () {
        if (syfIdentifier) {
            dispatch(resetAlertsData());
            dispatch(getAllAlerts());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, syfIdentifier]);
    useEffect(function () {
        if (isError) {
            dispatch(setProfileApiError(error === null || error === void 0 ? void 0 : error.message));
        }
        else {
            dispatch(setContactInfo({ phone: phone, email: email }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, email, isError, phone]);
    // // On ComponentDidMount  Get Alerts
    useEffect(function () {
        loadAlerts();
    }, [loadAlerts]);
    useEffect(function () {
        // only trigger pageload analytics for manage alerts page
        if (isPageLoaded) {
            var _a = analyticsHelper.pageEvents.ALERTS, PAGE_FUNCTION = _a.PAGE_FUNCTION, NAME = _a.NAME, PAGE_KIND = _a.PAGE_KIND;
            var siteIdentifier = analyticsHelper.siteIdentifier[platform];
            var pnl = analyticsHelper.pnl[platform];
            // trigger analytics on page load for selected account
            alertsTriggerAnalyticsEvent({
                clientName: clientId,
                message: analyticsAccountInfoMessage,
                countryLanguage: currentLanguage,
                token: SyfStorage.getCorrelationId(),
                pageFunction: PAGE_FUNCTION,
                pageName: NAME,
                pageKind: PAGE_KIND,
                previouslyVisited: '',
                siteIdentifier: siteIdentifier,
                product: productType,
                pnl: pnl
            });
        }
    }, [
        currentLanguage,
        analyticsAccountInfoMessage,
        isPageLoaded,
        platform,
        productType,
        clientId
    ]);
    if (hasError) {
        return (_jsx(ErrorPage, { isPageLoaded: isPageLoaded, analyticsAccountInfoMessage: analyticsAccountInfoMessage }));
    }
    return (_jsx(Suspense, __assign({ fallback: _jsx(AlertsLazyLoader, {}) }, { children: _jsxs(_Fragment, { children: [!isLoading && _jsx(ContactInformationCard, {}), _jsx(TermsConsentBanner, {}), _jsx(AlertList, { "data-test": "AlertList", hasAlerts: isAlertsDataLoaded })] }) })));
};
export default Alerts;
